/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GuardarSolicitudPrestamoME { 
    codigoFrecuenciaPago?: string;
    codigoSubCalificacionContable?: string;
    nombreCliente?: string;
    codigoTipoPrestamo?: string;
    diaDePago?: number;
    secuencialCliente?: number;
    secuencialEmpresa?: number;
    secuencialCondicionTablaAmortizacion?: number;
    numeroCuotas?: number;
    frecuenciaPago?: number;
    montoSolicitado?: number;
    fechaAdjudicacion?: Date;
}